module.exports = __webpack_public_path__ + "static/media/share.66c0cb5e.svg";